import { useEffect } from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import GoogleCallback from './pages/GoogleCallback';
import CompleteProfile from './pages/CompleteProfile';
import EmailVerification from './pages/EmailVerification';
import ConfirmForgotPassword from './pages/ConfirmForgotPassword';
import BugReportButton from './components/BugReport/BugReportButton';
import { saveTenantFromBase64 } from './services/clientService';
import './App.css';

function App() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // If a `client` query-param is present (base64-encoded JSON with `tenant`),
    // decode it and persist it as a session cookie before the OAuth flow begins.
    const clientParam = searchParams.get('client');
    if (clientParam) {
      saveTenantFromBase64(clientParam);
    }
  }, [searchParams]);

  return (
    <div className="app">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/confirm-forgot-password" element={<ConfirmForgotPassword />} />
        <Route path="/google-callback" element={<GoogleCallback />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/verify-email" element={<EmailVerification />} />

        {/* Redirect any other path (including root) to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>

      <BugReportButton />
    </div>
  );
}

export default App;
